var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectCheckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.75 1.75 0.75 1.75 1 4 C-0.9375 6.25 -0.9375 6.25 -3 8 C-4.32 7.34 -5.64 6.68 -7 6 C-6.67 4.68 -6.34 3.36 -6 2 C-4.68 2 -3.36 2 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#005898",
    transform: "translate(20,5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectCheckBlue);
export default __webpack_public_path__ + "static/media/select_check_Blue.084aa46601accf0134979a215aaee7b6.svg";
export { ForwardRef as ReactComponent };